import React from 'react';
import cx from 'classnames';
import { CustomButton } from '../Button/Button';
import { Icon } from '../Icon';
import styles from './CloseButton.module.scss';
import { useTranslation } from 'react-i18next';

const CloseButton = ({ onClose, variant = 'primary', className, type }) => {

  const { t } = useTranslation();

  return (
    <CustomButton onClick={onClose} className={cx(styles.closeBtn, styles[variant], className)} variant="link" type={type} ariaLabel={t('general.close')}>
      <Icon src="close" className={styles.closeIcon} verticalAlign="middle" />
    </CustomButton>
  );
};

export default CloseButton;
